<template>
	<div>
		<v-row>
			<v-col cols="12" class="pb-0">
				<v-form @submit.prevent="submit">
					<v-text-field
						v-model="text"
						:loading="loading"
						:disabled="loading"
						color="primary"
						dense
						filled
						outlined
						:error-messages="
							alreadyExist ? 'Ya existe un documuento con este nombre' : ''
						"
						label="Nuevo documento"
						type="text"
						hint="Ejemplo: Carnet de conducir"
					>
						<template v-slot:append>
							<v-btn
								:disabled="!text || alreadyExist"
								:loading="loading"
								small
								color="success"
								type="submit"
							>
								Solicitar
								<v-icon right>mdi-send</v-icon>
							</v-btn>
						</template>
					</v-text-field>
				</v-form>
			</v-col>
		</v-row>
		<v-expand-transition>
			<v-row v-if="Boolean(chipSelected)">
				<v-col cols="12" md="5">
					<v-file-input
						id="uploads"
						v-model="documents"
						:disabled="loadingDocuments"
						outlined
						:label="chipSelected.type"
						filled
						dense
						single-line
					/>
				</v-col>
				<v-col cols="12" md="5">
					<v-menu
						ref="menu"
						v-model="menu"
						:close-on-content-click="false"
						:return-value.sync="date"
						transition="scale-transition"
						offset-y
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								v-model="date"
								dense
								filled
								readonly
								clearable
								outlined
								placeholder="*opcional"
								label="Fecha de vencimiento"
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker v-model="date" outlined locale="es" no-title scrollable>
							<v-spacer></v-spacer>
							<v-btn text color="primary" @click="menu = false">Cancelar</v-btn>
							<v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
						</v-date-picker>
					</v-menu>
				</v-col>
				<v-col cols="12" md="2" class="mt-2">
					<v-btn
						block
						:loading="loadingDocuments"
						small
						color="primary"
						@click="uploadDocuments"
					>
						Subir
					</v-btn>
				</v-col>
			</v-row>
		</v-expand-transition>
		<v-row v-if="hasDocuments || hasTypeDocuments" justify="center" class="pt-0">
			<v-col v-if="hasDocuments" sm="12" :md="hasTypeDocuments ? '6' : '12'">
				<v-list two-line dense>
					<v-subheader>Documentos disponibles</v-subheader>
					<v-list-item-group color="primary" style="max-height: 180px; overflow: auto;">
						<template v-for="(req, i) in person.typeDocument">
							<template v-if="req !== null">
								<v-list-item
									v-if="person.documents[i]"
									:key="i"
									:disabled="disabledList"
									tile
									link
									target="_blank"
									:href="person.documents[i].url"
								>
									<v-list-item-avatar>
										<v-icon
											v-if="itsDue(person.documents[i].date)"
											color="warning"
										>
											mdi-clock-alert-outline
										</v-icon>
										<v-icon v-else color="success">
											mdi-checkbox-marked-circle-outline
										</v-icon>
									</v-list-item-avatar>
									<v-list-item-content class="text-left">
										<v-list-item-title class="text-capitalize">
											{{ person.documents[i].type }}
										</v-list-item-title>
										<v-list-item-subtitle
											v-if="itsDue(person.documents[i].date)"
											style="font-size: 8pt;"
											class="warning--text"
										>
											Caducado el {{ person.documents[i].date }}
										</v-list-item-subtitle>
										<v-list-item-subtitle v-else style="font-size: 8pt;">
											Creado:
											{{ createdAt(person.documents[i].createdAt) }}
											{{
												person.documents[i].date &&
													`- Vence: ${person.documents[i].date}`
											}}
										</v-list-item-subtitle>
									</v-list-item-content>
									<v-list-item-action>
										<v-btn
											class="elevation-0"
											color="accent"
											fab
											x-small
											:disabled="disabledList"
											@click.prevent="openDialogDelete(i)"
										>
											<v-icon>mdi-close</v-icon>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
							</template>
						</template>
					</v-list-item-group>
				</v-list>
			</v-col>
			<v-col v-if="hasTypeDocuments" sm="12" :md="hasDocuments ? '6' : '12'">
				<v-list two-line dense>
					<v-subheader>Documentos pendientes</v-subheader>
					<v-list-item-group color="primary" style="max-height: 180px; overflow: auto;">
						<template v-for="(req, i) in person.typeDocument">
							<template v-if="req !== null && !person.documents[i]">
								<v-list-item
									:key="i"
									tile
									:disabled="disabledList"
									@click="toggleSelected(req, i)"
								>
									<v-list-item-avatar>
										<v-icon color="warning">
											mdi-file-question-outline
										</v-icon>
									</v-list-item-avatar>
									<v-list-item-content>
										<v-list-item-title class="text-left text-capitalize">
											{{ req.type }}
										</v-list-item-title>
									</v-list-item-content>
									<v-list-item-action>
										<v-btn
											class="elevation-0"
											color="accent"
											fab
											:disabled="disabledList"
											x-small
											@click.stop="openDialogDelete(i)"
										>
											<v-icon>mdi-close</v-icon>
										</v-btn>
									</v-list-item-action>
								</v-list-item>
							</template>
						</template>
					</v-list-item-group>
				</v-list>
			</v-col>
		</v-row>
		<v-row v-else>
			<v-col>
				<Empty msj="No hay documentos" />
			</v-col>
		</v-row>
		<dialog-confirm
			title="Estas seguro de eliminar"
			:dialog="dialogConfirm"
			:close="() => closeDialogDelete()"
			:confirm="() => close(itemToDelete)"
			:loading="disabledList"
		/>
	</div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import Empty from '@/components/ui/DataEmpty';
import moment from 'moment';

export default {
	components: { Empty, DialogConfirm: () => import('@/components/ui/DialogConfirm') },
	props: {
		person: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			dialogConfirm: false,
			itemToDelete: null,
			date: null,
			menu: false,
			disabledList: false,
			indexSelected: null,
			chipSelected: null,
			documents: null,
			loading: false,
			loadingDocuments: false,
			text: '',
		};
	},
	computed: {
		hasDocuments() {
			return (
				this.person.documents.length && this.person.documents.some(item => item !== null)
			);
		},
		hasTypeDocuments() {
			return this.person.typeDocument.some(
				(item, i) => item !== null && !this.person.documents[i]
			);
		},
		alreadyExist() {
			let text = this.text || '';
			text = text.toLowerCase();
			return this.person.typeDocument.some(
				typeDocument => typeDocument !== null && typeDocument.type.toLowerCase() === text
			);
		},
	},
	methods: {
		openDialogDelete(item) {
			this.itemToDelete = item;
			this.dialogConfirm = true;
		},
		closeDialogDelete() {
			this.itemToDelete = null;
			this.dialogConfirm = false;
		},
		itsDue(date) {
			return moment(date).isBefore(moment().format());
		},
		async submit() {
			this.loading = true;
			const payload = {
				_id: this.person._id,
				typeDocument: { type: this.text },
			};
			await this.setTypeDocument(payload);
			this.text = '';
			this.loading = false;
		},
		async uploadDocuments() {
			if (this.documents && this.person.typeDocument) {
				this.loadingDocuments = true;
				this.disabledList = true;
				let data = {
					_id: this.person._id,
					documents: this.documents,
					typeDocument: [...this.person.typeDocument],
				};
				data.typeDocument[this.indexSelected] = {
					...data.typeDocument[this.indexSelected],
					done: true,
					isEditing: true,
					date: this.date,
				};
				const person = await this.upload(data);
				this.setPersons(person);
				this.documents = null;
				this.chipSelected = null;
				this.disabledList = false;
				this.loadingDocuments = false;
			}
		},
		toggleSelected(req, i) {
			if (this.chipSelected) {
				this.indexSelected = null;
				this.documents = null;
				this.chipSelected = null;
			} else {
				this.chipSelected = req;
				this.indexSelected = i;
			}
		},
		async close(i) {
			this.disabledList = true;
			await this.deleteDocument({ id: this.person._id, index: i });
			this.closeDialogDelete();
			this.disabledList = false;
		},
		createdAt(createdAt) {
			if (createdAt) return moment(createdAt).format('l');
			else return 'Sin fechas';
		},
		...mapMutations({
			setPersons: 'Person/setPersons',
		}),
		...mapActions({
			deleteDocument: 'Person/deleteDocument',
			setTypeDocument: 'Person/setTypeDocument',
			upload: 'Person/upload',
		}),
	},
};
</script>
